import React from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { translate } from 'admin-on-rest';
import equal from 'deep-equal';
import { compose } from 'recompose';
import {
  MenuItem,
  SelectField,
  List,
  ListItem,
  Checkbox,
} from 'material-ui';
import Star from 'material-ui/svg-icons/toggle/star';
import StarBorder from 'material-ui/svg-icons/toggle/star-border';
import { compact } from 'lodash';
import plz from 'await-plz';

const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'rgb(245, 245, 245)',
    padding: '1em',
    alignItems: 'start',
  },
  link: {
    wordBreak: 'break-all',
    marginLeft: '1em',
    padding: '1em',
    backgroundColor: 'rgb(255,255,255)',
  },
};

const menuItems = (values, venues) => (
  venues && venues.sort((a, b) => {
    if (a.placeId.toLowerCase() < b.placeId.toLowerCase()) return -1;
    if (a.placeId.toLowerCase() > b.placeId.toLowerCase()) return 1;
    return 0;
  }).map((venue) => (
    <MenuItem
      key={venue.placeId}
      value={venue.placeId}
      primaryText={venue.placeId}
      checked={values && values.indexOf(venue.placeId) !== -1}
      insetChildren
    />
  ))
);

// eslint-disable-next-line no-shadow
const VenueList = translate(({ input: { value, onChange }, values, preferred, handleVenueChange, handlePreferredChange, venues, translate }) => (
  <div style={styles.wrapper}>
    <h5>{translate('resources.venues.fields.tableBooking.href')}</h5>
    <div>
      <SelectField
        multiple
        hintText="Select a name"
        value={values}
        onChange={(e, i, vals) => {
          let link = `https://booking.pinchos.se/?places=${vals.join(',')}`;
          if (vals.length > 1 && vals.includes(preferred)) {
            link = `${link}&preferredPlace=${preferred}`;
          } else if (vals.length === 2 && !preferred) {
            link = `${link}&preferredPlace=${vals[0]}`;
          }
          onChange(link);
          handleVenueChange(vals);
        }}
      >
        {menuItems(values, venues)}
      </SelectField>
      <List>
        {values.map((val) => (
          <ListItem
            leftCheckbox={
              <Checkbox
                disabled={values.length <= 1}
                onCheck={(e) => {
                  const link = `https://booking.pinchos.se/?places=${values.join(',')}&preferredPlace=${e.target.value}`;
                  onChange(link);
                  handlePreferredChange(e.target.value);
                }}
                value={val}
                checked={val === preferred}
                checkedIcon={<Star />}
                uncheckedIcon={<StarBorder />}
              />
            }
            primaryText={val}
          />
        ))}
      </List>
    </div>
    {value && <a style={styles.link} href={value}>{value}</a>}
  </div>
));

export class BookingLinkBuilder extends React.Component {
  constructor(props) {
    super(props);
    const link = props.record.tableBooking ? props.record.tableBooking.href : '';
    let preferred;
    let values;
    if (link.indexOf('&') !== -1) { // has preferredPlace
      values = link.substring(link.indexOf('=') + 1, link.indexOf('&')).split(',');
      preferred = link.substring(link.indexOf('preferredPlace=') + 'preferredPlace='.length);
    } else {
      values = link.substring(link.indexOf('places=') + 'places='.length).split(',');
    }

    this.state = {
      venues: [],
      values: compact(values),
      preferred: preferred || '',
    };
  }

  componentDidMount = async () => {
    const url = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';
    const [resErr, venues] = await plz(fetch(`${url}/utils/parse/place`, { credentials: 'include' }));
    if (resErr || !venues) return console.error('failed to fetch venue', resErr);
    return this.setState({ venues });
  };

  shouldComponentUpdate = (nextProps, nextState) => !equal(this.props, nextProps) || !equal(this.state, nextState);

  handleVenueChange = (values) => {
    let preferred = '';
    if (values.length > 1 && values.includes(this.state.preferred)) {
      ({ preferred } = this.state);
    } else if (values.length === 2 && !this.state.preferred) {
      [preferred] = values;
    }
    this.setState({ values, preferred });
  };
  handlePreferredChange = (preferred) => this.state.preferred === preferred ? null : this.setState({ preferred });


  render() {
    const { source } = this.props;
    return (
      <Field
        name={source}
        component={(props) => (
          <VenueList
            {...props}
            {...this.state}
            handleVenueChange={this.handleVenueChange}
            handlePreferredChange={this.handlePreferredChange}
          />
        )}
      />
    );
  }
}

const enhance = compose(
  translate
);

export default connect((state) => state)(enhance(BookingLinkBuilder));
